// app/javascript/application.js

import "@hotwired/turbo-rails"
import "./controllers"
import AOS from "aos"

document.addEventListener("turbo:load", () => {
  document.documentElement.classList.add("js-aos")

  AOS.init({
    duration: 650,
    easing: "ease-out-cubic",
    offset: 28,
    once: true,
    mirror: false
  })
})

document.addEventListener("turbo:render", () => {
  AOS.refresh()
})
